export const COMPANY = {
  name: "Omkaar Metals Ltd",
  number: "120261053235",
  location: "Lusaka, Zambia",
  email: "info@omkaarmetals.com",
  phone: "+260 772 872 339",
  whatsapp: "https://wa.me/260772872339",
  phone2: "+91 89827 00005",
  whatsapp2: "https://wa.me/918982700005",
};

export const IMAGES = {
  coalHero: "https://images.unsplash.com/photo-1783476502475-499ab2fe52a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxjb2FsJTIwYmxhY2slMjBzdG9uZSUyMG1hY3JvfGVufDB8fHx8MTc4OTkyNDYxOXww&ixlib=rb-4.1.0&q=85",
  coalMine: "https://images.unsplash.com/photo-1517999144091-3d9dca6d1e43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwY29hbCUyMG1pbmluZyUyMGRhcmt8ZW58MHx8fHwxNzg5OTI0NjM2fDA&ixlib=rb-4.1.0&q=85",
  coalTexture: "https://images.pexels.com/photos/10483447/pexels-photo-10483447.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  copper: "https://images.unsplash.com/photo-1614535683569-129faaa108f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxjb3BwZXIlMjBtZXRhbCUyMHRleHR1cmV8ZW58MHx8fHwxNzg5OTI0NjE5fDA&ixlib=rb-4.1.0&q=85",
  aluminium: "https://images.unsplash.com/photo-1681108212545-04cabe9cf771?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxhbHVtaW51bSUyMG1ldGFsJTIwYmFyc3xlbnwwfHx8fDE3ODk5MjQ2MTl8MA&ixlib=rb-4.1.0&q=85",
  president: "https://upload.wikimedia.org/wikipedia/commons/c/c5/Hakainde_Hichilema_2022_%28cropped%29.jpg",
};

export const FOUNDERS = [
  {
    id: "01",
    name: "Navpreet Singh",
    role: "Founder & Managing Director",
    img: "/founders/navpreet.png",
    bio: "Ten years in Zambia's mineral trade — from pit floors in the Copperbelt to bulk coal contracts with buyers across Africa and Asia. Navpreet built Omkaar Metals on one rule: a founder inspects the cargo before anyone ships it. He personally leads sourcing, grading and every export negotiation, and after a decade in the trade he knows every yard, every grade and every route out of the country.",
  },
  {
    id: "02",
    name: "Khush Aulakh",
    role: "Co-Founder — Exports & Logistics",
    img: "/founders/khush.jpeg",
    bio: "A decade of moving commodities out of landlocked Southern Africa — rail, road and port. Khush runs freight coordination, export documentation and buyer relations between Lusaka and India, making sure every tonne leaves on schedule and lands exactly as promised. Ten years in the game, zero missed vessels.",
  },
];

export const PRODUCTS = [
  {
    id: "copper",
    name: "Copper Ingots",
    tag: "10% off LME — min 100 MT",
    featured: true,
    img: "copper",
    desc: "High-purity copper ingots from Zambia's Copperbelt at 10% below LME prices. Minimum order 100 MT, shipping worldwide. Payment: 30% advance, balance on arrival at your destination port.",
    specs: ["10% below LME price", "MOQ 100 MT", "30% advance · 70% at port", "SGS inspection on request"],
  },
  {
    id: "coal",
    name: "Coal",
    tag: "In stock — ready to ship",
    featured: false,
    img: "coalHero",
    desc: "All kinds and grades of Zambian coal — quite simply the cheapest coal on the world market, because Zambia is sitting on oceans of it. Graded, stockpiled and cleared for immediate export. First come, first served.",
    specs: ["Thermal & coking grades", "Bulk vessel or container loads", "FOB / CIF terms", "SGS inspection on request"],
  },
  {
    id: "aluminium",
    name: "Aluminium Ingots",
    tag: "Available on order",
    featured: false,
    img: "aluminium",
    desc: "Aluminium ingots in standard commercial grades, supplied in bulk for foundries and manufacturers.",
    specs: ["Standard commercial grades", "Bundled & palletised", "Mill certificates provided"],
  },
];
